import { FormControl, MenuItem, Select } from "@mui/material";
import { BentoCategory, VaNicheSpecificDetails } from "schemas/dashboard";
import { CustomEvent } from "schemas/functions";

import styles from "../styles";

interface Props {
  categoriesToPickFrom: BentoCategory[];
  niche: VaNicheSpecificDetails;
  onChange: (e: CustomEvent) => void;
}

const PickerDropdown = ({ categoriesToPickFrom, niche, onChange }: Props) => {
  return (
    <FormControl fullWidth>
      <Select
        displayEmpty
        name="bentoCategoryId"
        sx={styles.textField}
        value={niche?.bento_category_id || ""}
        onChange={onChange}
      >
        <MenuItem value="">
          <em>Pick Niche</em>
        </MenuItem>
        {categoriesToPickFrom.map((category) => (
          <MenuItem key={category.id} value={category.id}>
            {category.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default PickerDropdown;
